<template>
  <div>
    <card>
      <div class="card-header-custom">
        <button type="submit" class="btn btn-fill btn-primary"
          @click="$router.push('/cost_centers/create')"
        >
          <i class="fa fa-plus"></i> Hinzufügen
        </button>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <table class="table table-striped">
            <thead>
              <tr>
                <th width="10px">&nbsp;</th>
                <th>Name</th>
                <th>&nbsp;</th>
              </tr>
            </thead>
            <draggable v-model="costCenters" tag="tbody" handle=".handle"
              @end="updateOrder"
            >
              <tr v-for="costCenter in costCenters" :key="costCenter.id">
                <td class="handle"><i class="fas fa-arrows-alt-v"></i></td>
                <td v-text="costCenter.name"></td>
                <td class="text-right">
                  <div class="td-actions">
                    <a v-tooltip.top-center="'Bearbeiten'" class="btn btn-warning btn-link btn-xs"
                       @click="editCostCenter(costCenter)">
                      <i class="fa fa-edit"></i>
                    </a>
                    <a v-tooltip.top-center="'Löschen'" class="btn btn-danger btn-link btn-xs"
                       @click="deleteCostCenter(costCenter)">
                      <i class="fa fa-close"></i>
                    </a>
                  </div>
                </td>
              </tr>
            </draggable>
          </table>
        </div>
      </div>
    </card>
  </div>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  components: { draggable },
  data () {
    return {
      costCenters: []
    }
  },
  methods: {
    editCostCenter (costCenter) {
      this.$router.push(`/cost_centers/${costCenter.id}/edit`)
    },
    async deleteCostCenter (costCenter) {
      if (confirm(`Kostenstelle ${costCenter.name} wirklich löschen?`)) {
        await this.initCsrf()

        this.$http.delete(`/cost_centers/${costCenter.id}`).then(({ data }) => {
          this.$notify({
            message: `Kostenstelle ${data.name} erfolgreich gelöscht.`,
            type: 'success'
          })
          const index = this.costCenters.findIndex(({ id }) => data.id === id)
          this.costCenters.splice(index, 1)
        })
      }
    },
    async updateOrder () {
      await this.initCsrf()

      const costCenters = this.costCenters.reduce((costCenters, costCenter, idx) => ({ ...costCenters, [costCenter.id]: idx }), {})
      this.$http.put(`/cost_centers`, { cost_centers: costCenters })
    }
  },
  created () {
    this.$http.get('/cost_centers').then(({ data }) => { this.costCenters = data })
  }
}
</script>
